import { useEffect, useState } from 'react'

/** Reactive CSS media query. Returns true when it matches. */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  )
  useEffect(() => {
    const mq = window.matchMedia(query)
    const on = () => setMatches(mq.matches)
    on()
    mq.addEventListener('change', on)
    return () => mq.removeEventListener('change', on)
  }, [query])
  return matches
}

/**
 * Where the controls live. A bottom sheet on phones held upright; a floating
 * side panel on anything wide — tablets, desktops, and phones turned landscape,
 * where a bottom sheet would bury most of an already short map.
 * Keep in sync with the `--side` breakpoint comments in styles.css.
 */
export const SIDE_PANEL_QUERY =
  '(min-width: 768px), (orientation: landscape) and (max-height: 540px) and (min-width: 560px)'

/** 'sheet' | 'side' */
export const useLayoutMode = () => (useMediaQuery(SIDE_PANEL_QUERY) ? 'side' : 'sheet')

/** A mouse or trackpad: hover tooltips and zoom buttons make sense. */
export const useFinePointer = () => useMediaQuery('(hover: hover) and (pointer: fine)')
